<template>
<li class="kt-nav__item">
    <slot></slot>
</li>
</template>

<script>
export default {

}
</script>